<div>
  <div class="title margin-top-sm">
    <span class="drag-handle"></span>
  </div>
  @switch (data.type) {
    <!-- Filter Shipments - Select -->
    @case ('filter') {
      <div class="title margin-top-lg">
        {{ data.title }}
      </div>
      <div class="options margin-top-md">
        @for (option of data.options; track option) {
          <div class="margin-bottom-md" (click)="changeChosenValue(option)" data-test="list-of-options">
            <span [ngClass]="chosenValue !== option ? 'text-fade' : ''">{{ option }}</span>
            @if (chosenValue === option) {
              <mat-icon svgIcon="tick-blue"></mat-icon>
            }
          </div>
        }
      </div>
      <div class="margin-bottom-md margin-top-md">
        <button mat-button class="btn-accept" (click)="onConfirm()" data-test="confirm-filter-button">Confirm</button>
      </div>
    }
    <!-- Documents File -->
    @case ('file') {
      <div class="margin-top-lg" [ngClass]="loading ? 'action-container disabled-text' : 'action-container'">
        <div class="document-actions" (click)="downloadDocument()" data-test="download-button">
          <mat-icon svgIcon="download"></mat-icon>
          <span>Download</span>
        </div>
        @if (data.fileDocument.role === 'Driver') {
          <div class="document-actions" (click)="deleteDocument()" data-test="delete-button">
            <mat-icon svgIcon="delete-icon"></mat-icon>
            <span>Delete</span>
          </div>
        }
        <div class="document-actions" (click)="fetchDocument()" data-test="view-button">
          <mat-icon svgIcon="eye-line"></mat-icon>
          <span>View</span>
        </div>
      </div>
    }
    <!-- Timeline -->
    @case ('timeline') {
      <div [ngClass]="loading ? 'action-container disabled-text' : 'action-container'">
        @if (data.event.comment) {
          <div class="document-actions" (click)="openEditComment()" data-test="edit-comment">
            <mat-icon svgIcon="edit-filled"></mat-icon>
            <span>Edit</span>
          </div>
        }
        @if (data.event.comment) {
          <div class="document-actions" (click)="deleteEvent('comment')" data-test="delete-comment">
            <mat-icon svgIcon="delete-icon"></mat-icon>
            <span>Delete</span>
          </div>
        }
        @if (data.event.fileUrl) {
          <div class="document-actions" (click)="deleteEvent('documentId')" data-test="delete-photo">
            <mat-icon svgIcon="delete-icon"></mat-icon>
            <span>Delete</span>
          </div>
        }
      </div>
    }
  }
</div>
